import React from "react";
import { Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { setIsExpirationDate, setExpirationDate } from "../../../redux/slices/settings";
import { InfoIcon } from "../svg";
import { useDispatch, useSelector } from "react-redux";

const ExpirationDate = () => {
  const { isExpirationDate, lang, expiredDate } =
    useSelector((state) => ({
       lang: state.changeLang.language.restriction,
      isExpirationDate: state.settings.expiration.isExpirationDate,
      expiredDate: state.settings.expiration.expiredDate,
    }));
  const dispatch = useDispatch();
  return (
    <div className="mb-4">
    <div>
      <Form.Check
        type="checkbox"
        label={lang[43]}
        checked={isExpirationDate}
        onChange={() => {
          dispatch(setExpirationDate(""));
          dispatch(setIsExpirationDate(!isExpirationDate));
        }}
        id="expirationDateSetting"
        className="me-2 d-inline-block fw-bold"
      />
      <OverlayTrigger
        overlay={<Tooltip className="opacity-75">{lang[44]}</Tooltip>}
      >
        <div className="d-inline">
          <InfoIcon className="mb-1" />
        </div>
      </OverlayTrigger>
    </div>
      {isExpirationDate && (
        <Row className="g-3 mt-0">
          <Col md={6}>
            <Form.Control
              type="datetime-local"
              className="py-3"
              value={expiredDate}
              onChange={(e) => dispatch(setExpirationDate(e.target.value))}
            />
          </Col>
        </Row>
        )}
    </div>
  )
}
  export default ExpirationDate;